import PropTypes from 'prop-types'
import React, { Component } from 'react'

import { createShortcutHelper } from 'helpers/ShortcutHelpers'
import { Button, Text } from 'components/base'

class SendAndCancel extends Component {
  static propTypes = {
    onCancel: PropTypes.func.isRequired,
    hideCancel: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
    submitLabel: PropTypes.string.isRequired,
  }

  static defaultProps = {
    submitLabel: 'Send',
    hideCancel: false,
  }

  componentDidMount() {
    this.sendRef.scrollIntoView()
  }
  render() {
    const { onCancel, onSubmit, hideCancel, submitLabel } = this.props

    return (
      <div
        ref={ref => (this.sendRef = ref)}
        className="flexbox flexbox-align-center width-full"
      >
        {!hideCancel && (
          <Text.Action
            onClick={onCancel}
            className="margin-left-auto margin-right-medium"
          >
            Cancel
          </Text.Action>
        )}
        <Button.Primary onClick={onSubmit} slim>
          <div className="margin-right-small">{submitLabel}</div>
          <div className="font-size-smallest">
            {createShortcutHelper('cmd + enter')}
          </div>
        </Button.Primary>
      </div>
    )
  }
}

export default SendAndCancel
